import {useDispatch, useSelector} from "react-redux";
import {useEffect, useMemo, useState} from "react";
import {acquireActions} from "../../../../../../_actions";
import _ from "lodash";
import {AcquireCampaignBuilder} from "../objects/AcquireCampaignBuilder";
import {formatProactiveMetric} from "../../../Proactive/Utilities/CampaignUtils";
import moment from "moment";
import {buildMetricsDetailsUrl, ACQUIRE_CAMPAIGNS} from "../../../RetainDashboard/Utilities/CampaignUtils";
import CampaignActions from "components/v2/views/ProactiveMetricsDetail/Utilities/CampaignActions";

export default function (customParams) {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const { organization_id = '' } = JSON.parse(localStorage.user);
    const params = {
        startDate: customParams?.startDate || moment().subtract(2, 'years').startOf('day').toISOString(),
        endDate: customParams?.endDate || moment().endOf('day').toISOString(), // Current date, end of day
    };

    useEffect(() => {
        if(customParams) {
          if(customParams.organizationId) {
            dispatch(acquireActions.getOrganizationAcquireCampaigns(customParams.organizationId, params));  
         } 
        } else {
            dispatch(acquireActions.getCompanyAcquireCampaigns());
        }
    }, [customParams?.refreshTrigger]);

    const acquireCampaigns = useSelector(state => state.acquire)
    const loading = acquireCampaigns.loadingAcquireCampaign
    const campaignsObj = acquireCampaigns.acquireCampaigns;
    const campaignList = _.get(campaignsObj, 'items') || [];
    const totalCount = _.get(campaignsObj, 'totalCount') || 0;
    const rows = [];

    if(!loading && campaignList.length > 0) {
        campaignList.map( item => {
            const {campaign, metrics} = item;
            const builder = new AcquireCampaignBuilder()

            builder.setId(_.get(campaign, 'id') || '-');
            builder.setName(_.get(campaign, 'name') || '-');
            builder.setComments(_.get(metrics, 'comments') || '-');
            builder.setEngagementRate(_.get(metrics, 'engagementRate') || '-');
            builder.setEngagements(_.get(metrics, 'engagements') || '-');
            builder.setLikes(_.get(metrics, 'likes') || '-');
            builder.setReplies(_.get(metrics, 'replies') || '-');
            builder.setFollows(_.get(metrics, 'follows') || '-');
            builder.setFollowsRate(_.get(metrics, 'followsRate') || '-');
            if(customParams) builder.setActions(<CampaignActions campaign={builder.campaign} />);

            builder.setParam(buildMetricsDetailsUrl({
                id: _.get(campaign, 'id'),
                organizationId: customParams ? customParams.organizationId : organization_id
            }, ACQUIRE_CAMPAIGNS, params))
            rows.push(builder.campaign);
        })
    }

    const paginatedRows = useMemo(() => {
        return rows.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }, [rows, page]);

    const changePage = (nextPage) => {
        setPage(nextPage)
    }

    const baseColumns = [
        {
            id: 'name',
            label: 'Campaign name',
            width: 170,
            clickable: true,
            isSortable: true,
            withTooltip: true
        },
        {
            id: 'comments',
            label: 'Comments',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'engagementRate',
            label: 'Engagement Rate',
            width: 100,
            isSortable: true,
            align: 'right',
            format: formatProactiveMetric,
        },
        {
            id: 'engagements',
            label: 'Engagements',
            width: 170,
            clickable: true,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'likes',
            label: 'Likes',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'replies',
            label: 'Replies',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'follows',
            label: 'Follows',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'followsRate',
            label: 'Follows Rate',
            width: 100,
            isSortable: true,
            align: 'right',
            format: formatProactiveMetric,
        },
    ];
    const columns = !customParams ? baseColumns : [
        ...baseColumns,
        {
            id: 'actions',
            label: 'Actions',
            width: 30,
            align: 'right',
        },
    ];

    return { rows: paginatedRows, columns, totalCount, loading, changePage, page };
}
